
import { Component, mixins } from "nuxt-property-decorator";
import BaseLayoutMixin from "../../node_modules/sitis-nuxt/lib/cms/BaseLayoutMixin";
import PageBreadcrumbs from "~/components/UI/Breadcrumbs.vue";

@Component({
  components: { PageBreadcrumbs },
})
export default class MainLayout extends mixins(BaseLayoutMixin) {}
